import { render, staticRenderFns } from "./CoinsBySeries.vue?vue&type=template&id=18f8f49a&"
import script from "./CoinsBySeries.vue?vue&type=script&lang=js&"
export * from "./CoinsBySeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports